if (!customElements.get('product-form')) {
	customElements.define('product-form', class ProductForm extends HTMLElement {
		constructor() {
			super();

			this.form = this.querySelector('form');
			this.form.querySelector('[name=id]').disabled = false;
			this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
			this.minicart = document.querySelector('mini-cart');
			this.eventContext = this.form.dataset.eventContext;
			this.hideErrors = this.dataset.hideErrors === 'true';
			
			// Setup additional fields validation
			this.setupAdditionalFieldsValidation();
		}

		onSubmitHandler(event) {
			event.preventDefault();
			const submitButton = this.querySelector('[type="submit"]');
			if (submitButton.classList.contains('loading')) {
				return;
			}

			// Validate additional fields before submission
			if (!this.validateAdditionalFields()) {
				return;
			}

			this.handleErrorMessage();

			submitButton.setAttribute('aria-disabled', true);
			submitButton.classList.add('loading');
			this.querySelector('.button-overlay-spinner').classList.remove('hidden');

			const config = fetchConfig('javascript');
			config.headers['X-Requested-With'] = 'XMLHttpRequest';
			delete config.headers['Content-Type'];

			const formData = new FormData(this.form);
			let warrantyData;

			const selectedWarrantyOption = document.querySelector('input[name="warranty_input"]:checked');

			for (let [key, value] of formData.entries()) {
				if (key === 'warranty') {
					if(value !="") {
						warrantyData = value.split('|');
					} else {
						if(selectedWarrantyOption) {
							warrantyData = selectedWarrantyOption.value.split('|');
						}
					}
				}
			}

			if (warrantyData) {
				if(warrantyData.length > 1) {
					formData.append('properties[_bundleId]', warrantyData[0]);
					formData.append('properties[_percent]', warrantyData[1]);
				}
			} else {
				const warrantyElement = document.getElementById("warranty-options");
				if (warrantyElement) {
					const elementTop = warrantyElement.getBoundingClientRect().top + window.scrollY;
					const offset = (window.innerHeight / 2) - (warrantyElement.offsetHeight / 2);
					window.scrollTo({
					top: elementTop - offset,
					behavior: 'smooth'
					})
					warrantyElement.classList.add('important');

					submitButton.classList.remove('loading');
					submitButton.removeAttribute('aria-disabled');
					this.querySelector('.button-overlay-spinner').classList.add('hidden');

					setTimeout(() => {
					warrantyElement.classList.remove('important');
					}, 1000);
					submitButton.classList.remove('loading');
					submitButton.removeAttribute('aria-disabled');
					this.querySelector('.button-overlay-spinner').classList.add('hidden');
					return
				}
			}

			formData.append('sections', this.minicart.getSectionsToRender().map((section) => section.id));
			formData.append('sections_url', window.location.pathname);
			config.body = formData;

			fetch(`${routes.cart_add_url}`, config)
				.then((response) => response.json())
				.then((response) => {
					if (response.status) {
						publish(PUB_SUB_EVENTS.cartError, {
							source: 'product-form',
							productVariantId: formData.get('id'),
							errors: response.errors || response.description,
							message: response.message,
						});

						this.handleErrorMessage(response.description);
						this.minicart.updateSectionContents();
						return;
					}

					this.minicart.renderContents(response);

					if (window.themeSettings.redirectToCart) {
						location.href = '/cart';
					} else {
						this.minicart.open(submitButton);
					}

					publish(PUB_SUB_EVENTS.cartItemAdd, {
						source: this.eventContext,
						items: [response],
					});
				})
				.catch((e) => {
					console.error(e);
				})
				.finally(() => {
					submitButton.classList.remove('loading');
					submitButton.removeAttribute('aria-disabled');
					this.querySelector('.button-overlay-spinner').classList.add('hidden');
				});
		}

		handleErrorMessage(errorMessage = false) {
			if (this.hideErrors) {
				return;
			}

			this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form-error-message-wrapper');
			this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form-error-message');

			this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

			if (errorMessage) {
				this.errorMessage.textContent = errorMessage;
			}
		}

		validateAdditionalFields() {
			const additionalFields = this.querySelectorAll('.additional-field-input');
			let isValid = true;
			
			// Hide all error messages
			this.querySelectorAll('.field-error').forEach(error => {
				error.style.display = 'none';
			});
			
			// Check each field
			additionalFields.forEach(field => {
				const fieldId = field.id;
				const errorElement = this.querySelector(`#error-${fieldId}`);
				
				if (!field.value.trim()) {
					isValid = false;
					if (errorElement) {
						errorElement.style.display = 'block';
					}
					field.classList.add('error');
				} else {
					field.classList.remove('error');
				}
			});
			
			if (!isValid) {
				// Scroll to first error field
				const firstErrorField = this.querySelector('.additional-field-input.error');
				if (firstErrorField) {
					firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
					firstErrorField.focus();
				}
			}
			
			return isValid;
		}

		setupAdditionalFieldsValidation() {
			const additionalFields = this.querySelectorAll('.additional-field-input');
			
			additionalFields.forEach(field => {
				field.addEventListener('blur', function() {
					const fieldId = this.id;
					const errorElement = document.getElementById(`error-${fieldId}`);
					
					if (!this.value.trim()) {
						if (errorElement) {
							errorElement.style.display = 'block';
						}
						this.classList.add('error');
					} else {
						if (errorElement) {
							errorElement.style.display = 'none';
						}
						this.classList.remove('error');
					}
				});
				
				field.addEventListener('input', function() {
					const fieldId = this.id;
					const errorElement = document.getElementById(`error-${fieldId}`);
					
					if (this.value.trim()) {
						if (errorElement) {
							errorElement.style.display = 'none';
						}
						this.classList.remove('error');
					}
				});
			});
		}
	});
}
